import { render, staticRenderFns } from "./LayoutNavigation.vue?vue&type=template&id=c36ae222&"
import script from "./LayoutNavigation.vue?vue&type=script&lang=js&"
export * from "./LayoutNavigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports